import { ReadFileAsArrayBuffer } from './FileManipulation'
const shp = require('shpjs')

/**
 * Converte coordenadas em objetos LatLng no padrão do GoogleMaps
 * para conseguir renderizar o poligono
 * @param {Cooordenadas} coordinates
 */
const CoordenatesToGooglePattern = (coordinates, polygonType) => {
	const patternGooglePaths = []

	if (polygonType === 'MultiPolygon') {
		coordinates.forEach((arrayCoordinates) => {
			arrayCoordinates.forEach((coordinate) => {
				const patternGoogle = coordinate.map((latLng) => ({
					lat: latLng[1],
					lng: latLng[0],
				}))
				patternGooglePaths.push(patternGoogle)
			})
		})
	} else if (polygonType === 'Polygon') {
		coordinates.forEach((coordinate) => {
			const patternGoogle = coordinate.map((latLng) => ({
				lat: latLng[1],
				lng: latLng[0],
			}))
			patternGooglePaths.push(patternGoogle)
		})
	}

	return patternGooglePaths
}

/**
 * Remove a coordenada a mais que é gerado pelo shpjs
 */
const RemoveZPointFromShape = (coordinates) => {
	for (var index in coordinates) {
		if (typeof coordinates[index] == 'object' && coordinates[index] !== null) {
			RemoveZPointFromShape(coordinates[index])
		} else {
			if (coordinates.length !== 2) {
				coordinates.splice(coordinates.indexOf(0), 1)
			}
		}
	}
}

/**
 * Recebe um arquivo zip de shape e retorna geojson
 * @param {Arquivo zip} file
 */
const ZipFileToGeoJson = async function (file) {
	const fileArrayBuffer = await ReadFileAsArrayBuffer(file)
	const geojson = await shp(fileArrayBuffer)
	RemoveZPointFromShape(geojson.coordinates)

	return geojson
}

export { CoordenatesToGooglePattern, ZipFileToGeoJson }
